// every coin has maximum of numberCoinsInTube example below
// {
// 	'10' : 75,
// 	'20' : 75,
// 	'50' : 75,
// 	'100': 75,
// 	'200': 75,
// }

export const getGreatestNumberCoinsInTubes = (tubeDetails) => {
	const maxNumberCoinsInTube = tubeDetails.reduce((prev, current) => ((prev > current.numberCoinsInTube) ? prev : current.numberCoinsInTube), 0);

	return tubeDetails.reduce((acc, tubeDetail) => {
		acc[tubeDetail.valueCoinsInTube] = maxNumberCoinsInTube;
		return acc;
	}, {});
};
